import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
import { AdviseurCard } from '../components/Cards';
import { CTASection } from '../components/CTASection';
import { advisors } from '../data/mockData';
import { PageHero } from '../components/PageHero';
export function Adviseurs() {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredAdvisors = advisors.filter(advisor => advisor.name.toLowerCase().includes(searchTerm.toLowerCase()) || advisor.company.toLowerCase().includes(searchTerm.toLowerCase()) || advisor.location.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="w-full" data-id="element-239">
      <PageHero title={<>
            Vind uw <span className="font-medium" data-id="element-241">Adviseur</span>
          </>} subtitle="Ons netwerk bestaat uit onafhankelijke, gecertificeerde Register Valuators en ervaren M&A specialisten door heel Nederland." data-id="element-240">
        <div className="relative max-w-xl mt-10" data-id="element-242">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-243">
            <Search className="h-5 w-5 text-charcoal/50" data-id="element-244" />
          </div>
          <input type="text" className="block w-full pl-12 pr-4 py-4 rounded-full border-0 text-charcoal bg-white shadow-sm focus:ring-2 focus:ring-accent outline-none" placeholder="Zoek op naam, kantoor of stad..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-245" />
        </div>
      </PageHero>

      <section className="py-24 bg-offwhite min-h-[500px]" data-id="element-246">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12" data-id="element-247">
          {filteredAdvisors.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-248">
              {filteredAdvisors.map((advisor, index) => <AnimatedSection key={advisor.id} delay={index * 0.05} data-id="element-249">
                  <AdviseurCard {...advisor} data-id="element-250" />
                </AnimatedSection>)}
            </div> : <div className="text-center py-20" data-id="element-251">
              <p className="text-xl text-charcoal/60" data-id="element-252">
                Geen adviseurs gevonden voor "{searchTerm}".
              </p>
              <button onClick={() => setSearchTerm('')} className="mt-4 text-accent hover:underline" data-id="element-253">
                Wis zoekopdracht
              </button>
            </div>}
        </div>
      </section>

      <section className="py-16 bg-white border-b border-warmgray/50" data-id="element-254">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12" data-id="element-255">
          <AnimatedSection className="max-w-3xl mx-auto text-center" data-id="element-256">
            <h2 className="text-2xl font-light text-charcoal mb-4" data-id="element-257">
              Hoe werkt het?
            </h2>
            <div className="prose prose-lg text-charcoal/70 mx-auto" data-id="element-258">
              <p className="mb-4 text-left" data-id="element-259">
                Onze adviseurs zijn onafhankelijke, gecertificeerde specialisten
                (zoals Register Valuators) met diepgaande sectorkennis. Zij
                begeleiden u van A tot Z bij het bepalen van de waarde van uw
                onderneming.
              </p>
              <p className="mb-6 text-left" data-id="element-260">
                Via ons platform vindt u eenvoudig de juiste expert voor uw
                specifieke situatie. U kunt direct contact opnemen voor een{' '}
                <Link to="/bedrijfswaardering" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-261">
                  professionele bedrijfswaardering
                </Link>
                . Wij zorgen ervoor dat uw aanvraag bij de juiste persoon
                terechtkomt.
              </p>
              <Link to="/kennisbank/bedrijfswaardering/hoe-werkt-een-bedrijfswaardering" className="inline-flex items-center text-accent font-medium hover:underline" data-id="element-262">
                Lees meer over het waarderingsproces
              </Link>
            </div>
          </AnimatedSection>
        </div>
      </section>

      <CTASection light data-id="element-263" />
    </div>;
}